type EmailTemplateProps = {
  email: string
  subject: string
}

export const getEmailLink = ({ email, subject }: EmailTemplateProps) => {
  return `mailto:${email}?subject=${encodeURIComponent(subject)}`
}
